import React from 'react';

interface IStorefront {
  fill: string;
  width?: string;
  height?: string;
}

const Storefront = ({
  fill = '#6930CA',
  width = '32',
  height = '32',
}: IStorefront) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.2 11.8533L27.8 6.02667C27.5067 4.82667 26.4667 4 25.2534 4H6.73337C5.53337 4 4.48004 4.84 4.20004 6.02667L2.80004 11.8533C2.48004 13.2133 2.77337 14.6 3.62671 15.6933C3.73337 15.84 3.88004 15.9467 4.00004 16.08V25.3333C4.00004 26.8 5.20004 28 6.66671 28H25.3334C26.8 28 28 26.8 28 25.3333V16.08C28.12 15.96 28.2667 15.84 28.3734 15.7067C29.2267 14.6133 29.5334 13.2133 29.2 11.8533ZM25.2134 6.65333L26.6134 12.48C26.7467 13.04 26.6267 13.6 26.28 14.04C26.0934 14.28 25.6934 14.6667 25.0267 14.6667C24.2134 14.6667 23.5067 14.0133 23.4134 13.1467L22.64 6.66667L25.2134 6.65333ZM17.3334 6.66667H19.9467L20.6667 12.6933C20.7334 13.2133 20.5734 13.7333 20.2267 14.12C19.9334 14.4667 19.5067 14.6667 18.96 14.6667C18.0667 14.6667 17.3334 13.88 17.3334 12.92V6.66667ZM11.32 12.6933L12.0534 6.66667H14.6667V12.92C14.6667 13.88 13.9334 14.6667 12.9467 14.6667C12.4934 14.6667 12.08 14.4667 11.76 14.12C11.4267 13.7333 11.2667 13.2133 11.32 12.6933ZM5.38671 12.48L6.73337 6.66667H9.36004L8.58671 13.1467C8.48004 14.0133 7.78671 14.6667 6.97337 14.6667C6.32004 14.6667 5.90671 14.28 5.73337 14.04C5.37337 13.6133 5.25337 13.04 5.38671 12.48ZM6.66671 25.3333V17.2933C6.77337 17.3067 6.86671 17.3333 6.97337 17.3333C8.13337 17.3333 9.18671 16.8533 9.96004 16.0667C10.76 16.8667 11.8267 17.3333 13.04 17.3333C14.2 17.3333 15.24 16.8533 16.0134 16.0933C16.8 16.8533 17.8667 17.3333 19.0667 17.3333C20.1867 17.3333 21.2534 16.8667 22.0534 16.0667C22.8267 16.8533 23.88 17.3333 25.04 17.3333C25.1467 17.3333 25.24 17.3067 25.3467 17.2933V25.3333H6.66671Z"
      fill={fill}
    />
  </svg>
);

export default Storefront;
